import { getPersistedLanguage } from "@/lib/language-storage"

const GOOGLE_MAPS_SEARCH_URL = `https://www.google.com/maps/search/`

export const generateLocationLink = (address: string) => {
  const language = getPersistedLanguage()
  let baseUrl = GOOGLE_MAPS_SEARCH_URL
  if (language === "de") {
    baseUrl = baseUrl.replace(".com", ".ch")
  }
  return `${baseUrl}?api=1&query=${encodeURIComponent(address)}`
}
